module.exports = __webpack_public_path__ + "media/images/common/kuchi_2-3d8e9052a3900c2a0025175d31e20e34.gif";